import React from 'react';
import { Link } from 'react-router-dom';
import Icons from './Icons';
import karitsaLogo from '../assets/images/Karitsa/logo.jpg';
import efrenLogoMini from '../assets/images/Efren/logopeque.jpg';
import gesopsLogoMini from '../assets/images/GesOps/logo.png';
import jesusLogoMini from '../assets/images/JesusX/icono.png';
import therapyLogoMini from '../assets/images/Therapy Works/logo.png';

const LawyersList = ({ lawyers, stateName }) => {
  // Si no hay abogados para mostrar
  if (!lawyers || lawyers.length === 0) {
    if (!stateName) {
      return (
        <div className="no-selection">
          <h3>Selecciona un servicio o estado</h3>
          <p>Usa los filtros para encontrar profesionales en tu área.</p>
        </div>
      );
    }
    return (
      <div className="no-selection">
        <h3>No hay profesionales registrados</h3>
        <p>Actualmente no tenemos profesionales registrados en {stateName}.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="state-info">
        {stateName ? (
          <>
            <h2 className="state-name">{stateName}</h2>
            <p className="lawyers-count">
              {lawyers.length} {lawyers.length === 1 ? 'profesional disponible' : 'profesionales disponibles'}
            </p>
          </>
        ) : (
          <>
            <h2 className="state-name">Resultados de búsqueda</h2>
            <p className="lawyers-count">
              {lawyers.length} {lawyers.length === 1 ? 'profesional encontrado' : 'profesionales encontrados'}
            </p>
          </>
        )}
      </div>
      
      <div className="lawyers-list">
        {lawyers.map((lawyer) => {
          const CardWrapper = lawyer.isPremium && lawyer.slug ? Link : 'div';
          const cardProps = lawyer.isPremium && lawyer.slug 
            ? { to: `/abogado/${lawyer.slug}`, className: "lawyer-card clickable" }
            : { className: "lawyer-card" };
          
          return (
            <CardWrapper key={lawyer.id} {...cardProps}>
              {lawyer.backOfficeClient ? (
                // Clientes de Back Office (p.ej. KAR Legal Counsel): solo nombre de la firma + logo
                <div className="lawyer-header with-logo">
                  <h3 className="lawyer-name">{lawyer.firmName || lawyer.name}</h3>
                  <div className="lawyer-logo-mini">
                    <img src={karitsaLogo} alt={lawyer.firmName || 'Logo de la firma'} />
                  </div>
                </div>
              ) : lawyer.slug === 'efren-marrero' ? (
                // Efrén Marrero: nombre + logo de Sol y Justicia
                <div className="lawyer-header with-logo">
                  <h3 className="lawyer-name">{lawyer.name}</h3>
                  <div className="lawyer-logo-mini">
                    <img src={efrenLogoMini} alt={lawyer.firmName || lawyer.name} />
                  </div>
                </div>
              ) : lawyer.slug === 'gesops-llc' ? (
                // GesOps LLC: nombre + logo de GesOps
                <div className="lawyer-header with-logo">
                  <h3 className="lawyer-name">{lawyer.name}</h3>
                  <div className="lawyer-logo-mini">
                    <img src={gesopsLogoMini} alt={lawyer.firmName || lawyer.name} />
                  </div>
                </div>
              ) : lawyer.slug === 'jesus-rios-figueroa' ? (
                // Jesús X. Ríos-Figueroa: nombre + logo de JRios Law Group
                <div className="lawyer-header with-logo">
                  <h3 className="lawyer-name">{lawyer.name}</h3>
                  <div className="lawyer-logo-mini">
                    <img src={jesusLogoMini} alt={lawyer.firmName || lawyer.name} />
                  </div>
                </div>
              ) : lawyer.slug === 'therapy-works-counseling' ? (
                // Therapy Works Counseling: nombre + logo
                <div className="lawyer-header with-logo">
                  <h3 className="lawyer-name">{lawyer.name}</h3>
                  <div className="lawyer-logo-mini">
                    <img src={therapyLogoMini} alt={lawyer.firmName || lawyer.name} />
                  </div>
                </div>
              ) : (
                <>
                  <h3 className="lawyer-name">{lawyer.name}</h3>
                  {lawyer.firmName && (
                    <p className="lawyer-firm">{lawyer.firmName}</p>
                  )}
                </>
              )}
              <p className="lawyer-specialty">{lawyer.specialty}</p>
              <div className="lawyer-contact">
                <p>📍 {lawyer.city}</p>
                <p>📞 {lawyer.phone}</p>
                <p className="lawyer-email">✉️ {lawyer.email}</p>
              </div>
              {lawyer.isPremium && (
                <span className="premium-tag">⭐ Premium</span>
              )}
              {lawyer.backOfficeClient && (
                <>
                  <span className="backoffice-tag">🏢 Back Office by GesOps</span>
                  <div className="lawyer-social-mini">
                    <span className="social-label">Redes de la firma:</span>
                    <div className="social-icons-mini">
                      <span className="social-icon-mini" aria-label="Facebook">
                        <Icons.Facebook />
                      </span>
                      <span className="social-icon-mini" aria-label="Instagram">
                        <Icons.Instagram />
                      </span>
                      <span className="social-icon-mini" aria-label="TikTok">
                        <Icons.TikTok />
                      </span>
                    </div>
                  </div>
                </>
              )}
            </CardWrapper>
          );
        })}
      </div>
    </div>
  );
};

export default LawyersList;
